import { render, staticRenderFns } from "./ViewAnexos.vue?vue&type=template&id=37683f8b&"
import script from "./ViewAnexos.vue?vue&type=script&lang=js&"
export * from "./ViewAnexos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports